module.exports = __webpack_public_path__ + "assets/raleigh-recruitment-agency-5.5308fcfa.png";